import {DowntimeStoppage, IssueGroupingKey, StoppageCode} from '@domain/stoppages'
import {TFunction} from 'i18next'
import {useMemo} from 'react'

import {isUnavailable, getTheTitle} from '../utils'

import {useDepartmentNameMap} from './useDepartmentNameMap'

type UseGetTheTitleParams = {
  t: TFunction
  groupType:
    | IssueGroupingKey.MAIN_EQUIPMENT
    | IssueGroupingKey.EQUIPMENT_NUMBER
    | IssueGroupingKey.STOPPED_MAIN_EQUIPMENT
  groupId: string
  stoppageCode: string
  stoppagesDetails?: DowntimeStoppage[]
  stoppageConfig?: StoppageCode[]
}

export const useTitle = (params: UseGetTheTitleParams) => {
  const {groupType, groupId} = params

  const isStoppedMainEquipment = groupType === IssueGroupingKey.STOPPED_MAIN_EQUIPMENT
  const departmentUpmIds = useMemo(
    () => (isStoppedMainEquipment && !isUnavailable(groupId) ? [groupId] : []),
    [isStoppedMainEquipment, groupId]
  )

  const departmentNameMap = useDepartmentNameMap({
    departmentUpmIds,
    isEnabled: isStoppedMainEquipment
  })

  const baseTitle = getTheTitle(params)

  if (groupType !== IssueGroupingKey.STOPPED_MAIN_EQUIPMENT || isUnavailable(groupId)) {
    return baseTitle
  }

  const departmentName = departmentNameMap.get(groupId)
  return departmentName ? baseTitle.replace(groupId, departmentName) : baseTitle
}
